import React from 'react';
import { InspectorControls } from '@wordpress/block-editor';
import { PanelBody, RangeControl, ToggleControl, TextControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

const Panel = props => {
  const {
    setAttributes,
    attributes,
    onChangeAttribute = false,
    children = false
  } = props;

  const {
    itemsPerLine,
    showViewMoreButton,
    showTitle,
    image,
    enableSplit,
    enableGap,
    splitCount,
    __display = true
  } = attributes;
  return (
    <InspectorControls>
      <PanelBody title="Grid Settings">
        <label>Columns</label>
        <RangeControl
          onChange={itemsPerLine => {
            if (onChangeAttribute !== false) {
              onChangeAttribute({ itemsPerLine });
            }
          }}
          value={itemsPerLine}
          min={1}
          max={5}
          required
        />
        <ToggleControl
          label="Enable Split"
          checked={enableSplit}
          onChange={isChecked => {
            if (onChangeAttribute !== false)
              onChangeAttribute({
                enableSplit: isChecked
              });
          }}
        />
        <ToggleControl
          label="Enable Gap"
          checked={enableGap}
          onChange={isChecked => {
            if (onChangeAttribute !== false)
              onChangeAttribute({
                enableGap: isChecked
              });
          }}
        />
        {/* {enableSplit === 'Yes' && (
          <React.Fragment>
            <label>Items in page</label>
            <RangeControl
              onChange={splitCount => {
                if (onChangeAttribute !== false) {
                  onChangeAttribute({ splitCount });
                }
              }}
              value={splitCount}
              min={1}
              max={15}
              required
            />
          </React.Fragment>
        )} */}
        <ToggleControl
          label={__('Show View more button', 'newspack-blocks')}
          checked={showViewMoreButton}
          onChange={() => {
            if (onChangeAttribute !== false)
              onChangeAttribute({ showViewMoreButton: !showViewMoreButton });
          }}
        />
        <ToggleControl
          label={__('Show Grid Title', 'newspack-blocks')}
          checked={showTitle}
          onChange={() => {
            if (onChangeAttribute !== false)
              onChangeAttribute({ showTitle: !showTitle });
          }}
        />
        {children !== false && children}
      </PanelBody>
      <PanelBody title="Advanced" initialOpen={false}>
        <TextControl
          label={'Display'}
          value={__display}
          onChange={(val) => {
            onChangeAttribute({ __display: val });
          }}
        />

      </PanelBody>
    </InspectorControls>
  );
};

export default Panel